import { useState } from "react";

import _ from "lodash";
import styled, { css } from "styled-components";

const Input = (props) => {
    const { type = `text`, extra = ``, leftIcon, leftIconStyles = ``, rightIcon = {}, leftContent = null, onChange, regex, readOnly, onClick } = props;
    const [passwordVisible, setPasswordVisible] = useState(false);
    const _onChange = (e) => {
        if (regex) {
            e.target.value = e.target.value.replace(new RegExp(regex, "g"), ``);
        }
        onChange(e);
    };
    const _onClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    return (
        <Span type={type} extra={extra} readOnly={readOnly} onClick={_onClick}>
            {leftIcon && <Icon src={leftIcon} extra={`right: unset; left: 5px;` + leftIconStyles} />}
            {leftContent}
            <StyledInput {..._.omit(props, [`extra`, `onClick`])} type={type === `password` && passwordVisible ? `text` : type} onChange={_onChange} />
            {type === `password` ? (
                <Eye opened={passwordVisible} onClick={() => setPasswordVisible(!passwordVisible)} />
            ) : rightIcon?.src ? (
                <Icon {...rightIcon} />
            ) : null}
        </Span>
    );
};

const Icon = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background: url("${({ src }) => require(`../../assets/icons/${src}.svg`)}") no-repeat center center / contain;
    cursor: inherit;

    ${({ extra }) => extra}
`;

const Eye = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background: url("${(props) => require(`../../assets/icons/eye-${props.opened ? `on` : `off`}.svg`).default}") no-repeat center center / contain;
    cursor: pointer;
`;

const Span = styled.span`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;

    ${(props) => props.extra}

    border: unset;
    padding: unset;

    border-radius: 4px;
    border: 1px solid #dadada;

    box-sizing: border-box;

    ${({ readOnly }) =>
        readOnly &&
        css`
            cursor: default;
            background: #ebebeb;
        `}

    ${({ rightIcon }) => rightIcon && `padding-right: 30px;`}

    ${({ extra }) => extra}
`;

export const StyledInput = styled.input`
    &:focus {
        outline: none;
    }

    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.text.primary};
    display: flex;
    flex: 1;
    margin: 0;
    font-size: inherit;

    border: unset;
    background: transparent;
    padding: 18px 16px;

    ::-webkit-input-placeholder {
        color: ${({ theme }) => theme.text.secondary};
    }
    :-ms-input-placeholder {
        color: ${({ theme }) => theme.text.secondary};
    }

    ${({ readOnly }) =>
        readOnly &&
        css`
            cursor: default;
            color: #67686d;
        `}

    ${({ inputExtra }) => inputExtra}
`;

export default Input;
